import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import Styles from './CrossPostIcon.module.scss'
import { InstagramBrand } from 'blaze-ui/icons/24/InstagramBrand'
import LinkedInBrand from 'blaze-ui/icons/32/LinkedInBrand'
import { FacebookBrand } from 'blaze-ui/icons/35/FacebookBrand'
import TwitterBrand from 'blaze-ui/icons/20/TwitterBrand'
import { Google, TikTokBrand, YouTubeBrand } from 'blaze-ui/icons'
import { InstagramReelsBrand } from 'blaze-ui/icons/30'

const Icon = ({
  provider,
  isReels,
  size = 20,
}: {
  provider: ExternalIntegrationEnum
  isReels?: boolean
  size?: number
}) => {
  switch (provider) {
    case ExternalIntegrationEnum.Instagram:
      return isReels ? <InstagramReelsBrand size={size} /> : <InstagramBrand size={size} />
    case ExternalIntegrationEnum.LinkedIn:
      return <LinkedInBrand size={size} />
    case ExternalIntegrationEnum.Facebook:
      return <FacebookBrand size={size} />
    case ExternalIntegrationEnum.X:
      return <TwitterBrand size={size} />
    case ExternalIntegrationEnum.TikTok:
      return <TikTokBrand size={size} />
    case ExternalIntegrationEnum.YouTube:
      return <YouTubeBrand size={size} />
    case ExternalIntegrationEnum.GoogleBusinessProfile:
      return <Google size={size} />
    default:
      return null
  }
}

const CrossPostIcon = ({
  providers,
  isReels,
  size = 20,
}: {
  providers: ExternalIntegrationEnum[]
  isReels?: boolean
  size?: number
}) => {
  return (
    <div className={Styles.root}>
      {providers.map((provider) => (
        <div className={Styles.icon} key={provider}>
          <Icon provider={provider} isReels={isReels} size={size} />
        </div>
      ))}
    </div>
  )
}

export default CrossPostIcon
